import { Controller } from "@hotwired/stimulus";

// Disables form controls and reveals inline spinners while a Turbo form request
// is in flight (e.g. during a QBO re-sync triggered by line item mutations).
//
// Targets:
//   control  — the interactive element (select or button) to disable.
//              Buttons additionally have their content replaced with a spinner.
//   spinner  — a hidden element revealed alongside a disabled select.
export default class extends Controller {
  static targets = ["control", "spinner"];

  pending() {
    this.controlTargets.forEach((el) => {
      el.disabled = true;
      if (el.tagName === "BUTTON") {
        el.innerHTML =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
      }
    });
    this.spinnerTargets.forEach((el) => el.classList.remove("d-none"));
  }
}
